import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { hasPermission } from "../utils";
export function AuthorizeFactory(useAuthContext) {
    function Authorize(_a) {
        var permission = _a.permission, children = _a.children, renderProps = _a.render;
        var user = useAuthContext().user;
        var isAuthorized = hasPermission(user, permission);
        if (user && renderProps) {
            return renderProps({ isAuthorized: isAuthorized });
        }
        return isAuthorized ? _jsx(_Fragment, { children: children }, void 0) : null;
    }
    function withAuthorize(AuthorizedComponent, permission, UnauthorizedComponent) {
        var AuthorizeHOC = function () {
            return (_jsx(Authorize, { permission: permission, render: function (_a) {
                    var isAuthorized = _a.isAuthorized;
                    return isAuthorized ? (_jsx(AuthorizedComponent, {}, void 0)) : UnauthorizedComponent ? (_jsx(UnauthorizedComponent, {}, void 0)) : null;
                } }, void 0));
        };
        return AuthorizeHOC;
    }
    return { Authorize: Authorize, withAuthorize: withAuthorize };
}
export default AuthorizeFactory;
